var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{class:_vm.animar ? 'snackbar-zumbido' : '',attrs:{"color":_vm.color,"timeout":3000,"top":"","centered":""},on:{"input":_vm.onSnackbarChange},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "+_vm._s(_vm.mensaje)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }